import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { format, nextMonday, nextThursday } from "date-fns";
import { Subject, takeUntil } from "rxjs";
import { isValueInArrayValidator } from "src/app/libs/ui/utils/input-validators.utils";
import { FormsMetadata } from "src/app/pages/home-page/src/app/data-access/models/consts/find-trip-form.const";
import { FindTripFormGroupInterface } from "src/app/pages/home-page/src/app/data-access/models/interface/find-trip-form.interface";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";

@Component({
  selector: "tic-flight-search",
  templateUrl: "./flight-search.component.html",
  styleUrls: ["./flight-search.component.scss"],
})
export class FlightSearchComponent implements OnInit, OnDestroy, AfterViewInit {
  isOpen = false;
  selectedText: SafeHtml = "";
  oplst = false;
  @Output() onSubmitDetails: EventEmitter<FindTripFormGroupInterface> =
    new EventEmitter();
  readonly formsMetadata = FormsMetadata;
  inboundDate = new FormControl("");
  outboundDate = new FormControl("");
  datesFormGroup = new FormGroup({
    inboundDate: this.inboundDate,
    outboundDate: this.outboundDate,
  });

  originLocationCodeFormControl = new FormControl(
    this.formsMetadata["origin"].defaultValue()
  );
  destinationLocationCodeFormControl = new FormControl(
    this.formsMetadata["destination"].defaultValue()
  );
  numberOfAdultsFormControl = new FormControl(
    this.formsMetadata["numberOfAdults"].defaultValue()
  );
  paxesChildrenAgesFormControl = new FormControl();
  numberOfChildrenFormControl = new FormControl(
    this.formsMetadata["numberOfChildren"].defaultValue()
  );
  numberOfRoomsFormControl = new FormControl(
    this.formsMetadata["numberOfRooms"].defaultValue()
  );

  findTripFormGroup = new FormGroup({
    destinationLocationCode: this.destinationLocationCodeFormControl,
    numberOfAdults: this.numberOfAdultsFormControl,
    numberOfChildren: this.numberOfChildrenFormControl,
    paxesChildrenAges: this.paxesChildrenAgesFormControl,
    numberOfRooms: this.numberOfRoomsFormControl,
    originLocationCode: this.originLocationCodeFormControl,
  });

  formArray = new FormArray([this.findTripFormGroup, this.datesFormGroup]);
  wholeFormDetails!: FindTripFormGroupInterface;
  private destroy$: Subject<unknown> = new Subject();
  public adultval: number = 2;
  public roomVal: number = 1;
  public childval: number = 0;
  packageType: number = 1;
  readonly isValueInArrayValidator = isValueInArrayValidator;

  constructor(
    private elementRef: ElementRef,
    private sanitizer: DomSanitizer,
    private facadeCheckout: CheckoutFacade
  ) {}

  ngOnInit(): void {
    this.initFormGroupSubscriber();
    this.initDatesForm();
  }

  private initDatesForm(): void {
    const startDate = nextThursday(new Date());
    const endDate = nextMonday(startDate);
    this.datesFormGroup.setValue({
      inboundDate: format(startDate, "yyyy-MM-dd"),
      outboundDate: format(endDate, "yyyy-MM-dd"),
    });
    this.findTripFormGroup.get("numberOfAdults")?.setValue(2);
    this.adultval = 2;
    this.findTripFormGroup.get("numberOfRooms")?.setValue(1);
    this.roomVal = 1;
  }

  private initFormGroupSubscriber(): void {
    this.formArray.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        data.forEach(
          (item) =>
            (this.wholeFormDetails = {
              ...this.wholeFormDetails,
              ...item,
            })
        );
      });
  }

  onSubmit(): void {
    if (
      +this.numberOfChildrenFormControl.value > 0 &&
      this.wholeFormDetails.paxesChildrenAges == null
    ) {
      return;
    }
    this.facadeCheckout.resetOrderInfo();
    this.wholeFormDetails = {
      ...this.wholeFormDetails,
      numberOfRooms: this.numberOfRoomsFormControl.value,
      numberOfAdults: this.numberOfAdultsFormControl.value,
      numberOfChildren: this.numberOfChildrenFormControl.value,
      packageType: this.packageType,
    };
    this.onSubmitDetails.emit(this.wholeFormDetails);
  }

  ngAfterViewInit(): void {
    // Set default selectedText to the content of the first <li>
    const firstLi =
      this.elementRef.nativeElement.querySelector(".options ul li");
    this.selectedText = firstLi
      ? this.sanitizer.bypassSecurityTrustHtml(firstLi.innerHTML)
      : ""; // Use optional chaining and nullish coalescing
  }
  
  togglemd() {
    this.isOpen = !this.isOpen;
  }

  toggleOptions() {
    this.oplst = !this.oplst;
  }

  selectOption(event: any, packageType: number): void {
    this.packageType = packageType;
    // Set selectedText to the whole inner HTML of the clicked li element
    const clickedElement = event.target;
    const parentElement = clickedElement.closest("li");
    this.selectedText = this.sanitizer.bypassSecurityTrustHtml(
      parentElement.innerHTML
    );
    this.oplst = !this.oplst;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
